<template lang='pug'>
  .mobile-filter-sort(:class='filterSortClasses')
    .row
      .col-6
        button.sort-btn.btn.btn-block.btn-white(@click.prevent.stop='toggleMobileSort')
          span(v-text='$t("common.sortBy")')
          i.dropdown-arrow.dropdown-nav
      .col-6
        button.filter-btn.btn.btn-block.btn-white(@click.prevent='toggleMobileFilter')
          span(v-text='$t("products.filters.title")')
          span.filtered-tick(v-show='isFiltered')
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      filterCategorySlug: state => state.product.filterCategorySlug,
      filterBrandSlugs: state => state.product.filterBrandSlugs,
      filterPrice: state => state.product.filterPrice,
      filterCustomSlugs: state => state.product.filterCustomSlugs,
      filterOthers: state => state.product.filterOthers,
      showMobileSort: state => state.product.showMobileSort,
      showMobileFilter: state => state.layout.showMobileFilter,
      showSidebar: state => state.layout.showSidebar,
      isOffline: state => state.layout.isOffline
    }),
    ...mapGetters([
      'activeCategory'
    ]),
    isFiltered () {
      return (
        !!this.displayBrandSearch ||
        this.filterBrandSlugs.length > 0 ||
        Object.keys(this.filterPrice).length !== 0 ||
        this.filterCustomSlugs.length > 0 ||
        this.filterOthers.length > 0
      )
    },
    filterSortClasses () {
      return {
        'with-offline-banner': this.isOffline,
        'with-sign-in-banner': !this.currentUser,
        'with-sidebar': this.showSidebar
      }
    }
  },

  created () {
    window.addEventListener('click', this.closeMobileSort)
  },

  destroyed () {
    window.removeEventListener('click', this.closeMobileSort)
  },

  methods: {
    toggleMobileSort () {
      this.$store.commit('setShowMobileSort', !this.showMobileSort)
    },

    closeMobileSort () {
      if (this.showMobileSort) {
        this.$store.commit('setShowMobileSort', false)
      }
    },

    toggleMobileFilter () {
      this.$store.commit('setShowMobileFilter', !this.showMobileFilter)
      this.closeMobileSort()
    }
  }
}
</script>

<style scoped lang='scss'>
  .mobile-filter-sort {
    transition: top 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955), left 0.35s ease;
    background-color: $grey-light;
    display: block;
    position: fixed;
    left: 0;
    padding: 7px 10px;
    width: 100%;
    z-index: 2;

    &.with-sidebar {
      left: $sidebar-offset-left;
    }
  }

  .sort-btn,
  .filter-btn {
    border: 1px solid $grey;
    color: $black;
    text-transform: uppercase;
    @include font-weight-medium;
    padding: 13px 15px;

    &:active,
    &:focus,
    &:hover {
      opacity: 1;
    }
  }

  .filtered-tick {
    height: 15px;
    width: 15px;
    display: inline-block;
    margin-left: 7px;
    pointer-events: none;
    vertical-align: middle;
    background: url('../../../assets/images/icons/selected-tick.svg');
  }

  .dropdown-nav {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-left: 5px;
    margin-top: 0;
    position: relative;
  }
</style>
